import type { MediaUpload } from './types';

/**
 * Oturum içi medya önbelleği.
 * Backend mesaj DTO'sunda medya URL'i dönmüyor (yalnız hasMedia/mime/size);
 * panelden gönderilen medyanın önizlemesi için mesaj kimliği → yükleme eşlemesi tutulur.
 */
const cache = new Map<string, MediaUpload>();

export function rememberMedia(messageId: string, media: MediaUpload): void {
  cache.set(messageId, media);
}

export function mediaFor(messageId: string): MediaUpload | undefined {
  return cache.get(messageId);
}
